import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Card, CardContent, Typography, Menu, MenuItem, withTheme } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { PrimaryIconButton } from './'

const disabledColor = '#D6D6D6'

const styles = (theme: CentricTheme) => ({
  card:                 {
    minWidth:       224,
    maxWidth:       224,
    height:         96,
    cursor:         'pointer',
    display:        'flex',
    borderRadius:   2,
    '&:last-child': {
      padding: 0
    }
  },
  content:              {
    display:        'flex',
    '&:last-child': {
      padding: 0
    }
  },
  cardInfo:             {
    display:       'flex',
    flexDirection: 'column',
    flex:          4
  },
  subHeading:           {
    margin:   `${theme.spacing() * 2}px ${theme.spacing()}px 0`,
    flex:     3,
    width:    172,
    maxWidth: 172,
    height:   40
  },
  actions:              {
    width: 40,
    flex:  1
  },
  statusAndTag:         {
    color:  'rgba(27, 27, 27, 0.54)',
    margin: `${theme.spacing()}px ${theme.spacing() * 2}px ${theme.spacing() * 2}px`,
    flex:   1
  },
  '@keyframes loading': {
    '0%':   {backgroundColor: theme.colors.grey2},
    '20%':  {backgroundColor: theme.colors.grey3},
    '40%':  {backgroundColor: theme.colors.grey4},
    '60%':  {backgroundColor: theme.colors.grey5},
    '85%':  {backgroundColor: theme.colors.grey4},
    '100%': {backgroundColor: theme.colors.grey3}
  },
  loading:              {
    animationDuration:       `1s`,
    animationName:           `loading`,
    animationIterationCount: `infinite`,
    animationTimingFunction: 'ease-out'
  },
  inactive:             {
    pointerEvents:   'none',
    backgroundColor: disabledColor
  },
  description:          {
    whiteSpace:   'nowrap',
    overflow:     'hidden',
    textOverflow: 'ellipsis'
  }
})

interface MyProps extends StyledProps {
  title: string,
  description: string,
  raised?: boolean
  loading?: boolean
  onClick?: (e) => void
  actions?: Array<{ name: string, action: Function }>
  active?: boolean
}

@(withStyles as any)(styles)
export class TextOnlyCard extends React.Component<MyProps, { anchorEl?: HTMLElement }> {
  static defaultProps = {
    active: true
  }

  constructor(props) {
    super(props)
    this.state = {
      anchorEl: undefined
    }
  }

  handleClick = event => {
    this.setState({anchorEl: event.currentTarget})
  };

  handleClose = () => {
    this.setState({anchorEl: undefined})
  };

  render() {
    const {classes, title, description, actions, raised, loading, onClick, active} = this.props
    const {anchorEl} = this.state

    return (
      <div>
        <Card className={!active ? `${classes.inactive} ${classes.card}` : classes.card} raised={raised}>
          <CardContent className={classes.content}>
            <div className={classes.cardInfo} onClick={onClick}>
              <div className={`${classes.subHeading} ${loading ? classes.loading : ''}`} title={description}>
                {!loading && <Typography variant='body2' className={classes.description}> {description}</Typography>}
              </div>
              <div className={`${classes.statusAndTag} ${loading ? classes.loading : ''}`}>
                {!loading && <Typography variant='caption' className={classes.status}>{title}</Typography>}
              </div>
            </div>
            {actions &&
            <div>
              <div className={classes.actions}>
                <PrimaryIconButton icon={<MoreVert/>} aria-owns={anchorEl ? 'simple-menu' : undefined} aria-haspopup onClick={this.handleClick}/>
              </div>
              <Menu
                id='simple-menu'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}>
                {
                  actions.map(({name, action}) => (
                    <MenuItem key={name} onClick={() => {
                      action()
                      this.handleClose()
                    }}>{name}</MenuItem>)
                  )
                }
              </Menu>
            </div>
            }
          </CardContent>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/TextOnlyCard.tsx